
import { CompanyService } from "@/services/company-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {emailValidator} from "winfakt-vue-components/src/utils/validators";
import {generateRandomPassword} from "@/utils/passwords";
import { DbInfo } from "@/models/db-info";
import { ISelectItem } from "winfakt-vue-components";
import { MetricService } from "@/services";

export default FormLike.extend({
	data() {
		let activeUntil = new Date();
		activeUntil.setDate(activeUntil.getDate() + 14);
		return {
			availableDbs: [] as DbInfo[],
			apiKeyCopied: false,
			createdCompanyId: 0,
			createdApiKey: "",
			companyname: "",
			firstname: "",
			lastname: "",
			email: "",
			phone: "",
			password: "",
			repeatPassword: "",
			isValid: false,
			emailValidator,
			showPassword: false,
			activeUntil,
			notifyWithEmail: true,
			userIsActive: false,
			createApiKey: false,
			isAccountant: false,
			apiKeyContinueDisabled: false,
			dateCreated: null as null | Date,
			dbId: null as null | number
		};
	},
	props: {
		showCancelButton: Boolean,
		maxWidth: [String, Number],
		defaultDbId: Number
	},
	computed: {
		dbItems():ISelectItem<number | null>[] {
			let result:ISelectItem<number | null>[] = [{
				text: "Niet gespecifieerd",
				value: null
			}];

			result.push(...this.availableDbs.map(v=>{
				return {
					text: v.toString(),
					value: v.id
				};
			}));
			return result;
		},
	},
	watch: {
		defaultDbId: {
			immediate: true,
			handler(){
				this.dbId = this.defaultDbId;
			}
		}
	},
	methods: {
		samePasswordValidator(value:string):(boolean | string) {
			if (value != this.password){
				return "Passwords don't match";
			}
			return true;
		},
		async submit() {
			if (!this.isValid) return;
			let result = await CompanyService.createCompany({
				companyname: this.companyname,
				firstname: this.firstname,
				lastname: this.lastname,
				email: this.email,
				phone: this.phone,
				password: this.password,
				activeUntil: this.activeUntil,
				sendEmailToUser: this.notifyWithEmail,
				isUserActiveByDefault: this.userIsActive,
				createApiKey: this.createApiKey,
				isAccountant: this.isAccountant,
				dateCreated: this.dateCreated,
				dbId: this.dbId,
			});

			this.createdCompanyId = result.company.id;
			if (result.apiKey != ""){
				this.createdApiKey = "wfaPw77a" + result.apiKey;
			}else{
				this.$emit("company-id", this.createdCompanyId);
			}
		},
		async apiKeyContinue(){
			await this.$wf.dialog("Vergeet niet eerst het dossier te initializeren door aan te melden als klant.", "Ok", "Waarschuwing");
			this.apiKeyContinueDisabled = true;
			this.$emit("company-id", this.createdCompanyId);
		},
		generateRandomPassword(){
			this.password = generateRandomPassword();
			this.repeatPassword = this.password;
		},
		async copyApiKey(){
			await navigator.clipboard.writeText(this.createdApiKey);
			this.$wf.notify("API key coppied to clipboard", "info", 3000, "info");
			this.apiKeyCopied = true;
		},
		cancel(){
			this.$emit("cancel");
		}
	},
	async mounted(){
		this.availableDbs = await MetricService.getAllDbIds();
	}
});


